import styled from 'styled-components'
export const S_NotifyDebtors = styled.div`
  width: 650px;
  max-width: 100%;
  .btn-row {
    display: flex;
    justify-content: space-around;
    margin-top: 16px;
  }
  .email-preview {
    width: 100%;
    max-width: 100%;
    height: 600px;
    border: none;
    background-color: transparent;
  }
  .back-arrow {
    color: #c8c8c8;
    cursor: pointer;
  }
  .back-arrow:hover {
    color: #454545;
  }
  .preview {
    margin-right: 8px;
    color: #c8c8c8;
    cursor: pointer;
  }
  .preview:hover {
    color: #454545;
  }
`
